import script from "./ChipColorPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ChipColorPicker.vue?vue&type=script&setup=true&lang=js"

import "./ChipColorPicker.vue?vue&type=style&index=0&id=ec24f190&lang=css"

const __exports__ = script;

export default __exports__